import { render, staticRenderFns } from "./UserGroupPlanSelect.vue?vue&type=template&id=309a3d3c&lang=pug"
import script from "./UserGroupPlanSelect.vue?vue&type=script&lang=js"
export * from "./UserGroupPlanSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports